export enum CryptoProvider {
  FIREBLOCKS = 'FIREBLOCKS',
  COINMATE = 'COINMATE',
}
